var map = {
	"./aistudio-loading-logo.svg": 44741,
	"./appIcon_admin-panel.svg": 91465,
	"./appIcon_ai.svg": 70157,
	"./appIcon_fc.svg": 72586,
	"./appIcon_xa.svg": 88639,
	"./appIcon_xd.svg": 72003,
	"./appIcon_xi.svg": 19310,
	"./appIcon_xm.svg": 94946,
	"./appIcon_xp.svg": 18110,
	"./cloud-upload-alt-solid.svg": 76785,
	"./frontline-white.svg": 60942,
	"./frontline.svg": 39218,
	"./frontline_logo_dark.svg": 63723,
	"./frontline_logo_red.svg": 50491,
	"./frontline_logo_white.svg": 55500,
	"./ico_admin.svg": 95121,
	"./ico_aistudio.svg": 94279,
	"./ico_creator.svg": 10600,
	"./ico_dev.svg": 55734,
	"./ico_developer.svg": 64000,
	"./ico_xassist.svg": 70228,
	"./ico_xinspect.svg": 27405,
	"./ico_xmake.svg": 70175,
	"./ico_xpick.svg": 496,
	"./login-page.svg": 87594,
	"./ubimax-frontline-logo.svg": 67312,
	"./ubimax-frontline-logo_appLauncher.svg": 36439,
	"assets/images/logos/aistudio-loading-logo.svg": 44741,
	"assets/images/logos/appIcon_admin-panel.svg": 91465,
	"assets/images/logos/appIcon_ai.svg": 70157,
	"assets/images/logos/appIcon_fc.svg": 72586,
	"assets/images/logos/appIcon_xa.svg": 88639,
	"assets/images/logos/appIcon_xd.svg": 72003,
	"assets/images/logos/appIcon_xi.svg": 19310,
	"assets/images/logos/appIcon_xm.svg": 94946,
	"assets/images/logos/appIcon_xp.svg": 18110,
	"assets/images/logos/cloud-upload-alt-solid.svg": 76785,
	"assets/images/logos/frontline-white.svg": 60942,
	"assets/images/logos/frontline.svg": 39218,
	"assets/images/logos/frontline_logo_dark.svg": 63723,
	"assets/images/logos/frontline_logo_red.svg": 50491,
	"assets/images/logos/frontline_logo_white.svg": 55500,
	"assets/images/logos/ico_admin.svg": 95121,
	"assets/images/logos/ico_aistudio.svg": 94279,
	"assets/images/logos/ico_creator.svg": 10600,
	"assets/images/logos/ico_dev.svg": 55734,
	"assets/images/logos/ico_developer.svg": 64000,
	"assets/images/logos/ico_xassist.svg": 70228,
	"assets/images/logos/ico_xinspect.svg": 27405,
	"assets/images/logos/ico_xmake.svg": 70175,
	"assets/images/logos/ico_xpick.svg": 496,
	"assets/images/logos/login-page.svg": 87594,
	"assets/images/logos/ubimax-frontline-logo.svg": 67312,
	"assets/images/logos/ubimax-frontline-logo_appLauncher.svg": 36439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8235;